import * as yup from 'yup'
import { AbstractSchemaObject } from './abstract.schema'

export const registerObjectSchema = {
  firstName: yup.string().required('required field'),
  lastName: yup.string().required('required field'),
  email: AbstractSchemaObject.email,
  username: yup
    .string()
    .min(5)
    .max(10)
    .required('required field')
    .matches(/^[A-Za-z0-9]+$/, 'invalid format'),
  password: yup.string().min(5).required(),
  acceptTerms: yup
    .boolean()
    .oneOf([true], 'You must accept the terms and conditions'),
}

export const RegisterSchema = yup.object(registerObjectSchema)

export type RegisterSchemaType = yup.InferType<typeof RegisterSchema>
